module.exports = __webpack_public_path__ + "img/lectures.c0136849.png";